import React from 'react';
import Layout from '../../layout';
import DevHero from '../../assets/v2/png/developer-hero.png';
import DeveloperSectionOne from '../../components/Esper/Developer/DeveloperSectionOne';
import DeveloperSectionTwo from '../../components/Esper/Developer/DeveloperSectionTwo';
import messages from '../../i18n/en';

export default (props: any) => (
  <Layout
    ogImage={DevHero}
    messages={messages}
    location={props.location}
    title={`Developer Tools to Build, Test, and Debug Android Applications Remotely.`}
    keywords={`Android studio, API's, SDK's and CLI's for MDM`}
    description={`Esper's Android DevOps tools include APIs, SDKs, and CLIs to build, test, debug, and deploy Android apps for the enterprise in Android Studio.`}
    className="first-page"
  >
    <DeveloperSectionOne />
    <DeveloperSectionTwo />
  </Layout>
);
